try {
  class TeamStorePriceChart {
      constructor() {
        this.teamProductData = window.teamProductData || {};
        this.metaobject = this.teamProductData?.metaobject;
        this.viewModel = this.getViewModel(document.querySelector('.product-container'));
        this.tierPricing = null;
        this.upchargePrice = null;
        this.priceOverride = null;
        this.priceTier = null;

        this.init();
      }

      init() {
          if (!this.metaobject) {
              window.addEventListener('metaobjectDataRetrieved', (event) => {
                  this.metaobject = event.detail.metaobject;
                  this.bindEvents();
              });
          } else {
              this.bindEvents();
          }
      }

      bindEvents() {
          this.tierPricing = JSON.parse(this.metaobject.tier_pricing);
          this.upchargePrice = this.metaobject.upcharge_price;
          this.priceOverride = this.metaobject.price_override;

          // That price if exists should override any other price.
          if (+this.priceOverride) { // If empty string +"" => 0
              const overridePrice = this.calculatePrice(this.priceOverride);
              this.updatePrice(overridePrice);
              return;
          }

          if (this.teamProductData.isTeamAdmin) {
              this.priceTier = this.tierPricing[this.teamProductData.priceLevel.toLowerCase().replace(/ /g,"_")];
              if (this.priceTier && this.viewModel.$cartPropertiesPriceTierInput) this.viewModel.$cartPropertiesPriceTierInput.value = JSON.stringify(this.priceTier);
              this.setPriceRange(this.priceTier);

              return;
          }

          // Fallback to base price for non-admin users or if no priceOverride exists.
          const basePrice = this.calculatePrice(this.tierPricing.base_price.prices["Price 1"]);
          this.updatePrice(basePrice);
      }

      updatePrice(price) {
          this.hideInstallmentBlock();
          this.setNewPrice(this.formatPrice(price));
          this.setPriceToCartProperties(price);
      }

      /**
       * The installment widget is going to be wrong anyways because it's going to calculate based off the Shopify price,
       * which at time of this writing, was $9999.00, so hiding this avoids telling the customer they can get a t-shirt for the
       * low installment price of $902.49 a month.
       */
      hideInstallmentBlock() {
          const installmentForm = window.document.querySelector('#product-form-installment');
          if (installmentForm) {
              installmentForm.style.display = 'none';
          }
      }

      setPriceRange(priceTier) {
          const prices = Object.values(priceTier.prices);
          const minPrice = this.calculatePrice(Math.min(...prices));
          const maxPrice = this.calculatePrice(Math.max(...prices));

          if (minPrice === maxPrice) {
              this.setNewPrice(this.formatPrice(minPrice));
          } else {
              const formatedRangePrice = this.formatPrice(minPrice) + ' - ' + this.formatPrice(maxPrice);
              this.setNewPrice(formatedRangePrice);
          }
      }

      // To have "this" from context where its defined
      getPriceWithQuantityDiscount = (quantity) => {
          if (this.priceOverride) return +this.priceOverride;

          const { quantities, prices } = this.priceTier;
          const quantitiesArray = Object.values(quantities);
          const pricesArray = Object.values(prices);
          const maxQty = Math.max(...quantitiesArray);

          const thresholdIndex = quantity >= maxQty
            ? quantitiesArray.length - 1
            : Math.max(quantitiesArray.findIndex(q => (q - 1) >= quantity) - 1, 0);

          const adjustedPrice = this.calculatePrice(pricesArray[thresholdIndex]);
          this.setPriceToCartProperties(adjustedPrice);
          return adjustedPrice;
      }

      calculatePrice(initialPrice) {
          const upcharge = this.upchargePrice || 0;

          return parseFloat(initialPrice) + parseFloat(upcharge);
      }

      formatPrice(price) {
          return `$${Number.isInteger(+price) ? +price : +price.toFixed(2)}`;
      }

      setNewPrice(price) {
          this.viewModel.$priceText.innerHTML = price;
      }

      setPriceToCartProperties(price) {
          this.viewModel.$cartPropertiesPriceInput.value = price;
      }

      getViewModel(scope) {
          return {
              $embelishmentPrice: scope.querySelector('.embelishment-price'),
              $teamMoq: scope.querySelector('.team-moq'),
              $priceContainer: scope.querySelector('.product__info-container .pricing'),
              $cartPropertiesPriceInput: scope.querySelector('#ts_price'),
              $priceText: scope.querySelector('.price-item'),
              $cartPropertiesPriceTierInput: scope.querySelector('#ts_price_tier'),
          };
      }
  }

  window.shopifyClasses ??= {};
  window.shopifyClasses.TeamStorePriceChart = new TeamStorePriceChart();
} catch (e) {
  console.error("Error in TeamStorePriceChart class:", e)
}

try {
    class TeamProductPageDetails {
        constructor() {
          this.teamProductData = window.teamProductData;
          this.metaobject = window.teamProductData.metaobject;
          this.viewModel = this.getViewModel(document.querySelector('.product-container'));
          this.variables = {
          }

          this.init();
        }

        init() {
            if (!this.metaobject) {
              window.addEventListener('metaobjectDataRetrieved', (event) => {
                  this.metaobject = event.detail.metaobject;
                  this.bindEvents();
              });
            } else {
                this.bindEvents();
            }
        }

        bindEvents() {
            this.setEmbelishmentPrice();
            this.setMoq();
            this.setCartItemProperties();
        }

        setCartItemProperties() {
            const isJSON = (str) => {
                try {
                    JSON.parse(str);
                    return true;
                } catch (e) {
                    return false;
                }
            };

            for (const [ key, value] of Object.entries(this.metaobject)) {
                const inputElement = this.viewModel.cartProperties[`$${key}`];
                if (inputElement) {
                    inputElement.value = value;
                }
            } 

            if (this.teamProductData?.priceLevel) {
                this.viewModel.cartProperties.$price_level.value = this.teamProductData.priceLevel;
            }

            const collectionProductsData = this.teamProductData.teamStoreCollection.team_product_data;
            if (isJSON(collectionProductsData)) {
                const imageUrl = JSON.parse(collectionProductsData)[this.metaobject.entry_sku]?.imageLink;
                if (imageUrl) this.viewModel.cartProperties.$image.value = imageUrl;
            }

        }

        setEmbelishmentPrice() {
            const upcharge = this.metaobject.upcharge_price;

            if (upcharge && +upcharge !== 0) {
                this.viewModel.$embelishmentPrice.classList.remove('visually-hidden', 'visually-hidden--inline');
                this.viewModel.$embelishmentPrice.innerText = `(includes $${upcharge} for embellishment)`;
            }
        }

        setMoq() {
            const moq = this.metaobject.min_order_qty;

            if (moq && moq !== 0 && this.teamProductData.isTeamAdmin) {
                this.viewModel.$teamMoq.classList.remove('visually-hidden', 'visually-hidden--inline');
                this.viewModel.$teamMoq.innerText = `The minimum order quanity for this item is ${moq}`;
            }
        }

        getViewModel(scope) {
            return {
                $embelishmentPrice: scope.querySelector('.embelishment-price'),
                $teamMoq: scope.querySelector('.team-moq'),
                cartProperties: {
                    $price: scope.querySelector('#ts_price'),
                    $image: scope.querySelector('#ts_image'),
                    $min_order_qty: scope.querySelector('#ts_min_order_qty'),
                    $price_level: scope.querySelector('#ts_price_level'),
                    $opportunity_id: scope.querySelector('#ts_opportunity_id'),
                    $design_number: scope.querySelector('#ts_version_number'),
                    $customization_embellishment_type: scope.querySelector('#ts_customization_embellishment_type'),
                    $display_name: scope.querySelector('#ts_display_name'),
                    $entry_sku: scope.querySelector('#ts_entry_sku'),
                    $upcharge_price: scope.querySelector('#ts_upcharge'),
                    $back_print: scope.querySelector('#ts_back_print'),
                    $sleeve_print: scope.querySelector('#_ts_sleeve_print'),
                    $personalization: scope.querySelector('#ts_personalization'),
                },
            };
        }
    }

    new TeamProductPageDetails();
} catch (e) {
    console.error("Error in TeamProductPageDetails class:", e)
}

try {
  class CustomValidator {
      constructor() {
        this.viewModel = this.getViewModel(document.querySelector('.product-container'));
        this.metaobject = window.teamProductData.metaobject;
        this.init();
      }

      init() {
          if (!this.metaobject) {
            window.addEventListener('metaobjectDataRetrieved', (event) => {
                this.metaobject = event.detail.metaobject;
                this.bindEvents();
            });
          } else {
              this.bindEvents();
          }
      }

      bindEvents() {
          if (this.metaobject.personalization === "true") {
              this.setLastNameFunctionality();
              this.addTocartValidations();
          }
      }

      setLastNameFunctionality() {
          const { $noLastNameCheckbox, $inputGroup, $nameInput } = this.viewModel.lastNameOption;

          $noLastNameCheckbox?.addEventListener('change', () => {
            $inputGroup.style.display = $noLastNameCheckbox.checked ? 'none' : 'block';
            $nameInput.value = '';
          });
          $nameInput?.addEventListener('input', () => $nameInput.classList.remove('invalid'));
      }

      isCustomValidationPassed = () => {
          const { $noLastNameCheckbox, $nameInput } = this.viewModel.lastNameOption;

          // Validate Last name input only if personalization true and checkbox "No name" is not checked
          if (!$nameInput.value && !$noLastNameCheckbox.checked && this.metaobject.personalization === "true") {
              $nameInput.classList.add('invalid')
              return false;
          }

          return true;
      }

      addTocartValidations() {
        const { $ctaButtons } = this.viewModel;

        $ctaButtons.forEach((ctaButton) => {
            ctaButton.addEventListener('click', (event) => {
                if (!this.isCustomValidationPassed()) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            });
        });
      }

      getViewModel(scope) {
          return {
              $ctaButtons: scope.querySelectorAll(".product-form__submit"),

              lastNameOption: {
                $wrapper: scope.querySelector(".customization__last-name"),
                $noLastNameCheckbox: scope.querySelector(".customization__last-name .customization__toggle #no-last-name"),
                $inputGroup: scope.querySelector(".customization__last-name .customization__input-group"),
                $nameInput: scope.querySelector(".customization__last-name #Custom-Product-Text"),
              }
          };
      }
  }

  window.shopifyClasses ??= {};
  window.shopifyClasses.CustomValidator = new CustomValidator();
} catch (e) {
  console.error("Error in CustomValidator class:", e)
}
